import styled from 'styled-components/macro';
import { Navigate, Route, Routes } from 'react-router-dom';

import WalletHeader from './WalletHeader';
import WalletNav from './WalletNav';
// import { AssetsTab, SwapTab, LiquidityTab, StakingTab, NFTsTab } from './Tabs';
import { AssetsTab, StakingTab } from './Tabs';
import ValidatorPage from './Tabs/Staking/ValidatorPage';

const WalletWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;

  height: 100%;
  padding: 24px 40px;
`;

const navItems: WalletTabData[] = [
  {
    key: 'assets',
    label: 'Assets',
    content: <AssetsTab />,
  },
  // {
  //   key: 'swap',
  //   label: 'Swap Currencies',
  //   content: <SwapTab />,
  // },
  // {
  //   key: 'liquidity',
  //   label: 'Liquidity',
  //   content: <LiquidityTab />,
  // },
  {
    key: 'staking',
    label: 'Staking',
    content: <StakingTab />,
  },
  // {
  //   key: 'nft',
  //   label: 'NFTs',
  //   content: <NFTsTab />,
  // },
];

export default function Wallet() {
  return (
    <WalletWrapper>
      <WalletHeader />
      <WalletNav navItems={navItems} />
      <div style={{ height: '100%' }}>
        <Routes>
          <Route path="/" element={<Navigate replace to="assets" />} />
          {navItems.map(item => (
            <Route key={item.key} path={item.key} element={item.content} />
          ))}
          <Route path="/staking/:validatorId/*" element={<ValidatorPage />} />
        </Routes>
      </div>
    </WalletWrapper>
  );
}
